// extracted by mini-css-extract-plugin
export default {"privacy":"BitCoiner_privacy__Ex5I7","listLink":"BitCoiner_listLink__VLZjd"};